// Central place for API base URL so it can be shared across components
const API_BASE_URL = "https://pms.burrayhr.com";

export default API_BASE_URL;

